//import React from 'react'
import { Container } from "react-bootstrap";
import { Outlet, useNavigate } from "react-router";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useSelector, useDispatch } from "react-redux";
import useListenMessages from "./useListenMessages";

import Footer from "./components/Footer";

import { useEffect, useState } from "react";
import HeaderTop from "./components/HeaderTop";

const App = () => {
  // ENABLE THIS CODE FOR AUTO LOGOFF
  const { userInfo } = useSelector((state) => state.auth);

  const [mobileScreen, setMobileScreen] = useState(window.innerWidth < 600);

  // const dispatch = useDispatch();
  // const navigate = useNavigate();

  // const handleLogout = () => {
  //   dispatch(
  //     setCredentials({ ...userInfo, tableOrderDetails: {}, token: undefined })
  //   );
  //   navigate("/login");
  // };

  useEffect(() => {
    const handleResize = () => {
      setMobileScreen(window.innerWidth < 600);
    };

    // Add event listener for window resize
    window.addEventListener("resize", handleResize);

    // Cleanup the event listener when the component unmounts
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const [expandMenu, setExpandMenu] = useState(true);

  useListenMessages();

  return (
    <>
      <ToastContainer position="top-center" autoClose="3000" />
      <HeaderTop></HeaderTop>
      <main
        className="py-3"
        style={{
          height: "100vh",
          backgroundAttachment: "fixed",
          overflow: "scroll",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          marginBottom: "3rem",
        }}
      >
        <Container>
          <Outlet />
        </Container>
      </main>

      {!mobileScreen && <Footer />}
    </>
  );
};

export default App;
